import React from 'react';
import { useAnimationFrame } from 'react-timing-hooks';

import { useCurrentRoute } from './useCurrentRoute';

/**
 * Scrolls the given element to the top when the current route changes.
 */
export const useScrollToTopOnRouteChange = (element: HTMLElement | null): void => {
  const currentRoute = useCurrentRoute();
  const scroll = useAnimationFrame((element: HTMLElement | null) => {
    element?.scrollTo?.(0, 0);
  });

  // oxlint-disable-next-line @ms/no-react-namespace
  React.useEffect(() => {
    scroll(element);
  }, [currentRoute, element, scroll]);
};
